import { render, staticRenderFns } from "./ModalContentSendContractorEmail.vue?vue&type=template&id=20c060bd&scoped=true&"
import script from "./ModalContentSendContractorEmail.vue?vue&type=script&lang=js&"
export * from "./ModalContentSendContractorEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentSendContractorEmail.vue?vue&type=style&index=0&id=20c060bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c060bd",
  null
  
)

export default component.exports